import React from "react";

import { useRecoilState } from "recoil";
import { onboardingState } from "../../../store/onboardingState";

import RadioForm from "../../molecules/onboarding/radioForm";

const Step02 = ({ style }) => {
  const [onboardingStateAtom, setOnboardingStateAtom] =
    useRecoilState(onboardingState);

  const questionList03 = [
    {
      title: "1억~3억",
      value: "지식,대출 기초,재테크 기초,부동산 기초,경제 기초",
    },
    {
      title: "3억~6억",
      value: "지식,실전,대출 기초,부동산 기초,재테크 기초,경제 기초",
    },
    {
      title: "6억~10억",
      value: "지식,실전,대출 기초,부동산 중급,재테크 중급",
    },
    {
      title: "10억 초과",
      value: "실전,대출 기초,대출 중급,부동산 중급,재테크 중급",
    },
  ];
  const questionList04 = [
    {
      title: "실 거주를 위해서",
      value: "대출 기초,지식",
    },
    {
      title: "향후 거주할 목적으로 미리 사두기 위함",
      value: "대출 기초,지식",
    },
    {
      title: "실거주 없이 투자 목적",
      value: "대출 기초,대출 중급",
    },
    {
      title: "인플레이션 방어용으로 뭐든 사놓기 위해서",
      value: "대출 기초,대출 중급",
    },
  ];
  const questionList05 = [
    {
      title: "모른다.",
      value: "지식,대출 기초,재테크 기초,부동산 기초",
    },
    {
      title: "들어봤다.",
      value: "지식,대출 기초,부동산 기초",
    },
    {
      title: "대충 알고 있다.",
      value: "실전,대출 기초",
    },
    {
      title: "잘 알고 있다.",
      value: "실전,대출 중급,재테크 중급",
    },
  ];
  const questionList06 = [
    {
      title: "1천만원~5천만원",
      value: "지식,대출 기초,재테크 기초,부동산 기초,경제 기초",
    },
    {
      title: "5천만원~1억",
      value: "지식,실전,대출 기초,부동산 기초,재테크 기초,경제 기초",
    },
    {
      title: "1억~3억",
      value: "지식,실전,대출 기초,부동산 중급,재테크 중급",
    },
    {
      title: "3억 초과",
      value: "실전,대출 기초,대출 중급,부동산 중급,재테크 중급",
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        ...style,
      }}
    >
      <RadioForm
        questionList={questionList03}
        questionValue={onboardingStateAtom.question03}
        questionKey={"question03"}
        numbering={"03."}
        title={"대출을 통해 구매하려는 주택의 가격 범위는?"}
      />

      <RadioForm
        style={{
          marginTop: 60,
        }}
        questionList={questionList04}
        questionValue={onboardingStateAtom.question04}
        questionKey={"question04"}
        numbering={"04."}
        title={"대출을 통해 구매하려는 주택의 용도는 무엇인가요?"}
        radioStyle={{
          flexDirection: "column",
        }}
      />

      <RadioForm
        style={{
          marginTop: 60,
        }}
        questionList={questionList05}
        questionValue={onboardingStateAtom.question05}
        questionKey={"question05"}
        numbering={"05."}
        title={"정부 주도 주택 관련 대출에 대해 알고 계신가요?"}
      />

      <RadioForm
        style={{
          marginTop: 60,
        }}
        questionList={questionList06}
        questionValue={onboardingStateAtom.question06}
        questionKey={"question06"}
        numbering={"06."}
        title={"현재 주택구입을 위해 모아둔 자금은?"}
      />
    </div>
  );
};

export default Step02;
